import { Injectable } from '@angular/core';
import { Banner } from '@rockwell-automation-inc/common-utils';

@Injectable({
  providedIn: 'root',
})
export class BannerTrayService {
  addBannerToTray(bannerItems: Banner[], banner: Banner): Banner[] {
    const index = bannerItems.findIndex((item) => item.id === banner.id);
    if (index === -1) {
      return [...bannerItems, banner];
    }
    return bannerItems;
  }

  upsertBanner(bannerItems: Banner[], banner: Banner): Banner[] {
    const index = bannerItems.findIndex((item) => item.id === banner.id);
    if (index === -1) {
      return [...bannerItems, banner];
    }
    return bannerItems.map((item, i) => (i === index ? banner : item));
  }

  updateBannerMessage(bannerItems: Banner[], bannerId: string, message: string): Banner[] {
    const banner = bannerItems.find((item) => item.id === bannerId);
    if (!banner) {
      return bannerItems;
    }
    banner.message = message;
    return [...bannerItems];
  }

  hasBanner(bannerItems: Banner[], bannerId: string): boolean {
    return bannerItems.some((banner) => banner.id === bannerId);
  }

  closeBanner(bannerItems: Banner[], bannerId: string): Banner[] {
    const index = bannerItems.findIndex((item) => item.id === bannerId);
    return index === -1 ? bannerItems : bannerItems.filter((item) => item.id !== bannerId);
  }

  hideBanner(bannerItems: Banner[], banner: Banner): Banner[] {
    return this.closeBanner(bannerItems, banner.id);
  }
}
